// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sec-header {
  font-size: 15px;
  font-weight: 700;
  margin: 5px 0px 20px;
  color: #555B6D;
}

.box-row {
  margin: 0px 0px 25px;
}

.box-row .card {
  border-radius: 0px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.0392156863);
  border: 0px;
}

.box-row .card-header {
  background: #fff;
  border: 0px;
  color: #4D4F5C;
}

.card-header-title {
  font-size: 15px;
  font-weight: bold;
}

.box-row .card-body.gatepass-saveoutput {
  padding-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/dashboardData/dashBoardNum/DashBoardNum.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AACD;;AAEA;EACC,oBAAA;AACD;;AAEA;EACC,kBAAA;EACA,mDAAA;EACA,WAAA;AACD;;AAEA;EACC,gBAAA;EACA,WAAA;EACA,cAAA;AACD;;AAEA;EACC,eAAA;EACA,iBAAA;AACD;;AAEA;EACC,gBAAA;AACD","sourcesContent":[".sec-header {\n\tfont-size: 15px;\n\tfont-weight: 700;\n\tmargin: 5px 0px 20px;\n\tcolor: #555B6D;\n}\n\n.box-row {\n\tmargin: 0px 0px 25px;\n}\n\n.box-row .card {\n\tborder-radius: 0px;\n\tbox-shadow: 0px 2px 6px #0000000A;\n\tborder: 0px;\n}\n\n.box-row .card-header {\n\tbackground: #fff;\n\tborder: 0px;\n\tcolor: #4D4F5C;\n}\n\n.card-header-title {\n\tfont-size: 15px;\n\tfont-weight: bold;\n}\n\n.box-row .card-body.gatepass-saveoutput {\n\tpadding-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
